module.exports = __webpack_public_path__ + "static/media/cybervault.099d7157.jpg";